module.exports = __webpack_public_path__ + "static/media/scotia-vida-ico-beneficiario-rojo.e0c2f0e3.svg";